import React from 'react';
import classnames from 'classnames';

import './index.scss';

interface IAnalysePreviewProps extends IBaseProps {
  importLoading: boolean;
  isSuccessResult: boolean;
  illustrationContent: React.ReactNode;
}

const AnalysePreview: React.FC<IAnalysePreviewProps> = (props) => {
  const { style, className, importLoading, isSuccessResult, illustrationContent } = props;

  return (
    <div
      style={style}
      className={classnames('dbh-analyse-preview', className, {
        'dbh-analyse-preview--loading': importLoading,
        'dbh-analyse-preview--filled': isSuccessResult,
      })}
    >
      {illustrationContent}
    </div>
  );
};

export default AnalysePreview;
